import React from 'react';
import { Spinner, Table } from 'react-bootstrap';

import { formatNumberBR } from 'components/Relatorios/shared/RelatorioTable';
import Card from 'components/DesignSystem/Card';

import useDecompSecaoParams from 'hooks/Relatorios/Decomp/useDecompSecaoParams';
import { useGetDecompGeracaoQuery } from 'services/api/products/relatorios';

export default function GeracaoRenovavelUnsi() {
  const params = useDecompSecaoParams();

  const { data, isLoading } = useGetDecompGeracaoQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <Card title={data.titulo} className="relatorio-table">
      <Table responsive hover>
        <thead>
          <tr>
            <th rowSpan={2}>Subsistema</th>
            <th rowSpan={2}>Estágio</th>
            <th colSpan={3}>Previsão D-1</th>
            <th colSpan={3}>Diferenças com a previsão D-2</th>
          </tr>
          <tr>
            <th>P</th>
            <th>M</th>
            <th>L</th>
            <th>P</th>
            <th>M</th>
            <th>L</th>
          </tr>
        </thead>
        <tbody>
          {data.linhas.map((linha) => (
            <tr key={`${linha.subsistema}-${linha.estagio}`}>
              <td>{linha.subsistema}</td>
              <td>{linha.estagio}</td>
              <td>{formatNumberBR(linha.previsao_d1.p)}</td>
              <td>{formatNumberBR(linha.previsao_d1.m)}</td>
              <td>{formatNumberBR(linha.previsao_d1.l)}</td>
              <td className={linha.diferenca_d2.p < 0 ? 'relatorio-table__neg' : undefined}>
                {formatNumberBR(linha.diferenca_d2.p)}
              </td>
              <td className={linha.diferenca_d2.m < 0 ? 'relatorio-table__neg' : undefined}>
                {formatNumberBR(linha.diferenca_d2.m)}
              </td>
              <td className={linha.diferenca_d2.l < 0 ? 'relatorio-table__neg' : undefined}>
                {formatNumberBR(linha.diferenca_d2.l)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
}
